import { petSpeciesTuple } from '../../buruburu/pet/pet.ruleset';

export type SpeciesType = 'happy' | 'normal' | 'sad' | 'verysad' | 'dying';
export const speciesChatbot = petSpeciesTuple;

export type SpeciesChatbotType = typeof speciesChatbot[number];
type Species = `species/${SpeciesChatbotType}/${SpeciesType}`;

export const getPetAssetKey = (
  species: SpeciesChatbotType,
  type: SpeciesType = 'normal',
): Species => `species/${species}/${type}`;

export const speciesAssets: Record<Species, string> = {
  // Ball
  'species/ball/happy': 'private/chatbot/species/ball/happy.png',
  'species/ball/normal': 'private/chatbot/species/ball/normal.png',
  'species/ball/sad': 'private/chatbot/species/ball/sad.png',
  'species/ball/verysad': 'private/chatbot/species/ball/verysad.png',
  'species/ball/dying': 'private/chatbot/species/ball/dying.png',

  // Crab
  'species/crab/happy': 'private/chatbot/species/crab/happy.png',
  'species/crab/normal': 'private/chatbot/species/crab/normal.png',
  'species/crab/sad': 'private/chatbot/species/crab/sad.png',
  'species/crab/verysad': 'private/chatbot/species/crab/verysad.png',
  'species/crab/dying': 'private/chatbot/species/crab/dying.png',

  // Dog
  'species/dog/happy': 'private/chatbot/species/dog/happy.png',
  'species/dog/normal': 'private/chatbot/species/dog/normal.png',
  'species/dog/sad': 'private/chatbot/species/dog/sad.png',
  'species/dog/verysad': 'private/chatbot/species/dog/verysad.png',
  'species/dog/dying': 'private/chatbot/species/dog/dying.png',

  // Starball
  'species/starball/happy': 'private/chatbot/species/starball/happy.png',
  'species/starball/normal': 'private/chatbot/species/starball/normal.png',
  'species/starball/sad': 'private/chatbot/species/starball/sad.png',
  'species/starball/verysad': 'private/chatbot/species/starball/verysad.png',
  'species/starball/dying': 'private/chatbot/species/starball/dying.png',

  // Hamster
  'species/hamster/happy': 'private/chatbot/species/hamster/happy.png',
  'species/hamster/normal': 'private/chatbot/species/hamster/normal.png',
  'species/hamster/sad': 'private/chatbot/species/hamster/sad.png',
  'species/hamster/verysad': 'private/chatbot/species/hamster/verysad.png',
  'species/hamster/dying': 'private/chatbot/species/hamster/dying.png',

  // Turtle
  'species/turtle/happy': 'private/chatbot/species/turtle/happy.png',
  'species/turtle/normal': 'private/chatbot/species/turtle/normal.png',
  'species/turtle/sad': 'private/chatbot/species/turtle/sad.png',
  'species/turtle/verysad': 'private/chatbot/species/turtle/verysad.png',
  'species/turtle/dying': 'private/chatbot/species/turtle/dying.png',

  // Seaotter
  'species/seaotter/happy': 'private/chatbot/species/seaotter/happy.png',
  'species/seaotter/normal': 'private/chatbot/species/seaotter/normal.png',
  'species/seaotter/sad': 'private/chatbot/species/seaotter/sad.png',
  'species/seaotter/verysad': 'private/chatbot/species/seaotter/verysad.png',
  'species/seaotter/dying': 'private/chatbot/species/seaotter/dying.png',

  // Cat
  'species/cat/happy': 'private/chatbot/species/cat/happy.png',
  'species/cat/normal': 'private/chatbot/species/cat/normal.png',
  'species/cat/sad': 'private/chatbot/species/cat/sad.png',
  'species/cat/verysad': 'private/chatbot/species/cat/verysad.png',
  'species/cat/dying': 'private/chatbot/species/cat/dying.png',

  // Whale
  'species/whale/happy': 'private/chatbot/species/whale/happy.png',
  'species/whale/normal': 'private/chatbot/species/whale/normal.png',
  'species/whale/sad': 'private/chatbot/species/whale/sad.png',
  'species/whale/verysad': 'private/chatbot/species/whale/verysad.png',
  'species/whale/dying': 'private/chatbot/species/whale/dying.png',

  // Giraffe
  'species/giraffe/happy': 'private/chatbot/species/giraffe/happy.png',
  'species/giraffe/normal': 'private/chatbot/species/giraffe/normal.png',
  'species/giraffe/sad': 'private/chatbot/species/giraffe/sad.png',
  'species/giraffe/verysad': 'private/chatbot/species/giraffe/verysad.png',
  'species/giraffe/dying': 'private/chatbot/species/giraffe/dying.png',
};

/**
 * Pets images scaling ratio
 */
export const speciesAssetsRatio: Record<Species, string> = {
  // Ball
  'species/ball/happy': '348:331',
  'species/ball/normal': '1.04:1',
  'species/ball/sad': '1.03:1',
  'species/ball/verysad': '1.01:1',
  'species/ball/dying': '1:1.20',

  // Crab
  'species/crab/happy': '470:326',
  'species/crab/normal': '1.21:1',
  'species/crab/sad': '1.20:1',
  'species/crab/verysad': '1.20:1',
  'species/crab/dying': '1.07:1',

  // Dog
  'species/dog/happy': '450:346',
  'species/dog/normal': '1.06:1',
  'species/dog/sad': '1:1.04',
  'species/dog/verysad': '1:06:1',
  'species/dog/dying': '1:1.17',

  // Starball
  'species/starball/happy': '308:297',
  'species/starball/normal': '1.05:1',
  'species/starball/sad': '1.03:1',
  'species/starball/verysad': '1:1',
  'species/starball/dying': '1:1.09',

  // Hamster
  'species/hamster/happy': '338:285',
  'species/hamster/normal': '1.08:1',
  'species/hamster/sad': '1.07:1',
  'species/hamster/verysad': '1.06:1',
  'species/hamster/dying': '1:1.24',

  // Turtle
  'species/turtle/happy': '377:317',
  'species/turtle/normal': '1.06:1',
  'species/turtle/sad': '1:1',
  'species/turtle/verysad': '1:1',
  'species/turtle/dying': '1:1.13',

  // Seaotter
  'species/seaotter/happy': '330:330',
  'species/seaotter/normal': '1.01:1',
  'species/seaotter/sad': '1:1.04',
  'species/seaotter/verysad': '1:1.04',
  'species/seaotter/dying': '1:1.22',

  // Cat
  'species/cat/happy': '384:342',
  'species/cat/normal': '1:1.06',
  'species/cat/sad': '1:1.03',
  'species/cat/verysad': '1:1.04',
  'species/cat/dying': '1:1.23',

  // Whale
  'species/whale/happy': '339:323',
  'species/whale/normal': '1.06:1',
  'species/whale/sad': '1.34:1',
  'species/whale/verysad': '1:1.13',
  'species/whale/dying': '1:1.22',

  // Giraffe
  'species/giraffe/happy': '271:331',
  'species/giraffe/normal': '1:1.35',
  'species/giraffe/sad': '1:1.21',
  'species/giraffe/verysad': '1:1.35',
  'species/giraffe/dying': '1:1.32',
};
